import {useDispatch, useSelector} from "react-redux";
import {checkPermission, getCurrentUser, isEmpty} from "../../../../_helpers/commonFunctions";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import moment from "moment/moment";
import {setMyConnectedBanks} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import Alert from "react-bootstrap/esm/Alert";
import Input from "../../../common/Input";
import BetterCheckBox from "../../../common/BetterCheckBox";
import Dropdown from "../../../primer/Dropdown";
import {useTranslation} from "../../../../hooks/useTranslation";

const SystemTasks = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const myConnectedBanks = useSelector((state) => state.ACCOUNTING_DATA.myConnectedBanks);
    const [showUpdateProductBalance, setShowUpdateProductBalance] = useState(false);
    const [showUpdateClientBalance, setShowUpdateClientBalance] = useState(false);
    const [showUpdateSupplierBalance, setShowUpdateSupplierBalance] = useState(false);
    const [showUpdateClientInfo, setShowUpdateClientInfo] = useState(false);
    const [showUpdateSupplierInfo, setShowUpdateSupplierInfo] = useState(false);
    const [clientLoader, setClientLoader] = useState(false);
    const [supplierLoader, setSupplierLoader] = useState(false);
    const [productLoader, setProductLoader] = useState(false);
    const [clientUpdateLoader, setClientUpdateLoader] = useState(false);
    const [clientUpdateModalBody, setClientUpdateModalBody] = useState("");
    const [supplierUpdateModalBody, setSupplierUpdateModalBody] = useState("");
    const [supplierUpdateLoader, setSupplierUpdateLoader] = useState(false);
    const [disableSyncCP, setDisableSyncCP] = useState(false);
    const [showSyncModal, setShowSyncModal] = useState(false);
    const [showCreateCensus, setShowCreateCensus] = useState(false);
    const [showUpdateAssetBalance, setShowUpdateAssetBalance] = useState(false);
    const [assetBalanceLoader, setAssetBalanceLoader] = useState(false);

    const [showUpdateBankBalance, setShowUpdateBankBalance] = useState(false);
    const [bankBalanceLoader, setBankBalanceLoader] = useState(false);
    const [loadingMyAccounts, setLoadingMyAccounts] = useState(false);
    const [selectedBankAccount, setSelectedBankAccount] = useState("");

    const [firstLoad, setFirstLoad] = useState(true);
    const [censusSend, setCensusSend] = useState({
        year: "0",
        doClients: false,
        doClientsDate: "",
        doSuppliers: false,
        doSuppliersDate: "",
        doProducts: false,
        doProductsDate: "",
        doFixedAssets: false,
        doFixedAssetsDate: "",
    })
    const [censusLoad, setCensusLoad] = useState(false);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
            const y = String(Number(company.year) + 1);
            setCensusSend({
                ...censusSend,
                year: y,
                doClientsDate: `01/01/${y}`,
                doSuppliersDate: `01/01/${y}`,
                doProductsDate: `01/01/${y}`,
                doFixedAssetsDate: `01/01/${y}`,
            });
        }
    }, [firstLoad])

    useEffect(() => {
        if (showUpdateClientInfo) setClientUpdateModalBody("");
        if (showUpdateSupplierInfo) setSupplierUpdateModalBody("");
    }, [showUpdateClientInfo, showUpdateSupplierInfo])

    useEffect(() => {
        if (showUpdateBankBalance) {
            fetchMyAccounts();
        }
    }, [showUpdateBankBalance]);

    const handleConfirmUpdateProductBalance = async () => {
        setProductLoader(true);
        let requestData = {
            company: company.id,
            year: company.year,
            user: currentUser._id
        }
        await axios.post(`${process.env.REACT_APP_API_URL2}/settings/re-update-product-balance`, requestData, {headers: {"Content-Type": "application/json"}})
            .then((res) => {
                if (res.data.status === "200") {
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setProductLoader(false);
                setShowUpdateProductBalance(false);
            })
            .catch((error) => {
                console.log(error)
                toast.error(error);
                setProductLoader(false);
                setShowUpdateProductBalance(false);
            });
    };
    const handleConfirmUpdateClientBalance = async () => {
        setClientLoader(true);
        let requestData = {
            company: company.id,
            year: company.year,
            user: currentUser._id
        }
        await axios.post(`${process.env.REACT_APP_API_URL2}/settings/re-update-client-balance`, requestData, { headers: { "Content-Type": "application/json" }})
            .then((res) => {
                if (res.data.status === "200") {
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setClientLoader(false);
                setShowUpdateClientBalance(false);
            })
            .catch((error) => {
                console.log(error)
                toast.error(error);
                setClientLoader(false);
                setShowUpdateClientBalance(false);
            });
    }
    const handleConfirmUpdateSupplierBalance = async () => {
        setSupplierLoader(true);
        let requestData = {
            company: company.id,
            year: company.year,
            user: currentUser._id
        }
        await axios.post(`${process.env.REACT_APP_API_URL2}/settings/re-update-supplier-balance`, requestData, { headers: { "Content-Type": "application/json" }})
            .then((res) => {
                if (res.data.status === "200") {
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setSupplierLoader(false);
                setShowUpdateSupplierBalance(false);
            })
            .catch((error) => {
                console.log(error)
                toast.error(error);
                setClientLoader(false);
                setShowUpdateSupplierBalance(false);
            });
    }
    const handleConfirmUpdateClientInfo = async () => {
        setClientUpdateLoader(true);
        let requestData = {
            company: company.id,
            year: company.year,
            user: currentUser._id
        }
        await axios.post(`${process.env.REACT_APP_API_URL2}/settings/re-update-client-info`, requestData, { headers: { "Content-Type": "application/json" }})
            .then((res) => {
                if (res.data.status === "200") {
                    setClientUpdateModalBody(
                        <React.Fragment>
                            {t('SettingsSystemTasks.clientUpdateCompletedMessage1')}<br/>{t('SettingsSystemTasks.clientUpdateCompletedMessage2')+' '+res.data.totalCount}<br/>{t('SettingsSystemTasks.clientUpdateCompletedMessage3')+' '+res.data.modifiedCount}
                        </React.Fragment>
                    );
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setClientUpdateLoader(false);
            })
            .catch((error) => {
                console.log(error)
                toast.error(error);
                setClientUpdateLoader(false);
                setShowUpdateClientInfo(false);
            });
    }
    const handleConfirmUpdateSupplierInfo = async () => {
        setSupplierUpdateLoader(true);
        let requestData = {
            company: company.id,
            year: company.year,
            user: currentUser._id
        }
        await axios.post(`${process.env.REACT_APP_API_URL2}/settings/re-update-supplier-info`, requestData, { headers: { "Content-Type": "application/json" }})
            .then((res) => {
                if (res.data.status === "200") {
                    setSupplierUpdateModalBody(
                        <React.Fragment>
                            {t('SettingsSystemTasks.supplierUpdateCompletedMessage1')}<br/>{t('SettingsSystemTasks.supplierUpdateCompletedMessage2')+' '+res.data.totalCount}<br/>{t('SettingsSystemTasks.supplierUpdateCompletedMessage3')+' '+res.data.modifiedCount}
                        </React.Fragment>
                    );
                    toast.success(res.data.message);
                } else {
                    toast.error(res.data.message);
                }
                setSupplierUpdateLoader(false);
            })
            .catch((error) => {
                console.log(error)
                toast.error(error);
                setSupplierUpdateLoader(false);
                setShowUpdateSupplierInfo(false);
            });
    }
    const syncClientPaymentsWithSales = () => {
        setShowSyncModal(false);
        setDisableSyncCP(true);
        const requestData = {
            company: company.id,
            year: company.year,
            user: currentUser._id
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/settings/sync-client-payments-with-sales`, requestData, { headers: { "Content-Type": "application/json" }})
            .then((res) => {
                if(res.data.status === "200") {
                    toast.success("Ο συγχρονισμός έγινε με επιτυχία.");
                    setDisableSyncCP(false);
                } else {
                    toast.error("Κάτι πήγε στραβά");
                    setDisableSyncCP(false);
                }
            }).catch((err) => {
            console.log(err);
            setDisableSyncCP(false);
        })
    }
    const createCensusClicked = () => {
        const reqData = {...censusSend, company: company.id};
        if(censusSend.year === "0") {
            toast.error("Something went wrong with current year.");
        } else {
            setCensusLoad(true);
            axios.post(`${process.env.REACT_APP_API_URL2}/settings/create-new-year-census`, reqData, { headers: { "Content-Type": "application/json" }})
                .then((res) => {
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                    } else {
                        toast.error(res.data.message);
                    }
                    setCensusLoad(false);
                })
                .catch((err) => {
                    setCensusLoad(false);
                    console.log(err);
                })
        }
    }
    const createCensusInvalid = () => {
        return censusSend.year === "0"
            || (censusSend.doClients === false && censusSend.doProducts === false && censusSend.doSuppliers === false && censusSend.doFixedAssets === false)
            || isEmpty(censusSend.doClientsDate) || isEmpty(censusSend.doSuppliersDate) || isEmpty(censusSend.doProductsDate)
            || (!moment(censusSend.doClientsDate, "DD/MM/YYYY", true).isValid())
            || (!moment(censusSend.doSuppliersDate, "DD/MM/YYYY", true).isValid())
            || (!moment(censusSend.doProductsDate, "DD/MM/YYYY", true).isValid())
            || (!moment(censusSend.doFixedAssetsDate, "DD/MM/YYYY", true).isValid())
            || (moment(censusSend.doClientsDate, "DD/MM/YYYY", true).isValid() && String(moment(censusSend.doClientsDate, "DD/MM/YYYY").year()) !== censusSend.year)
            || (moment(censusSend.doSuppliersDate, "DD/MM/YYYY", true).isValid() && String(moment(censusSend.doSuppliersDate, "DD/MM/YYYY").year()) !== censusSend.year)
            || (moment(censusSend.doProductsDate, "DD/MM/YYYY", true).isValid() && String(moment(censusSend.doProductsDate, "DD/MM/YYYY").year()) !== censusSend.year)
            || (moment(censusSend.doFixedAssetsDate, "DD/MM/YYYY", true).isValid() && String(moment(censusSend.doFixedAssetsDate, "DD/MM/YYYY").year()) !== censusSend.year);
    }
    const handleConfirmUpdateAssetBalance = () => {
        setProductLoader(true);
        const requestData = {
            company: company.id,
            year: company.year,
            user: currentUser._id
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/settings/re-update-asset-balance`, requestData, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success(res.data.message);
            } else {
                toast.error(res.data.message);
            }
            setAssetBalanceLoader(false);
            setShowUpdateAssetBalance(false);
        }).catch((error) => {
            console.log(error)
            toast.error(error);
            setAssetBalanceLoader(false);
            setShowUpdateAssetBalance(false);
        })
    }

    const handleRecalculateBalances = () => {
        setBankBalanceLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-recalculate-balance`, {
            company: company.id,
            bankAccount: selectedBankAccount,
            year: company.year,
        }).then((res) => {
            setBankBalanceLoader(false);
            if (res.data.status === "200") {
                setShowUpdateBankBalance(false);
                toast.success("Επιτυχής επαναϋπολογισμός");
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setBankBalanceLoader(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchMyAccounts = () => {
        setLoadingMyAccounts(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-my-accounts`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                includeAll: "true",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const accs = res.data.data;
                if (accs?.length > 0) {
                    dispatch(setMyConnectedBanks(accs));
                }
            }
            setLoadingMyAccounts(false);
        }).catch((err) => {
            console.log(err);
            setLoadingMyAccounts(false);
        })
    }

    const accountOptions = myConnectedBanks.map((o) => {
        return {
            label: o.identifier,
            value: o.accountId,
            iban: o.iban,
            hooked: o.hooked,
        }
    }).filter(Boolean);

    return (
        <React.Fragment>
            <Row>
                <Col sm="12" className="d-flex align-items-center justify-content-start">
                    <span className="mr-3 mb-3">{t('SettingsSystemTasks.reUpdateProductsInventoryBalance')}</span>
                    {checkPermission("settings-generalsettings/systemtasks-write", permissionsData) &&
                        <Button
                            onClick={() => setShowUpdateProductBalance(true)} className="mb-3" type="button">
                            {t('SettingsSystemTasks.reupdate')}
                        </Button>
                    }
                </Col>
            </Row>
            <Row>
                <Col sm="12" className="d-flex align-items-center justify-content-start">
                    <span className="mr-3 mb-3">{t('SettingsSystemTasks.reUpdateClientBalance')}</span>{" "}
                    {checkPermission("settings-generalsettings/systemtasks-write", permissionsData) &&
                        <Button onClick={() => setShowUpdateClientBalance(true)} className="mb-3" type="button">{t('SettingsSystemTasks.reupdate')}</Button>
                    }
                </Col>
            </Row>
            <Row>
                <Col sm="12" className="d-flex align-items-center justify-content-start">
                    <span className="mr-3 mb-3">{t('SettingsSystemTasks.reUpdateSupplierBalance')}</span>{" "}
                    {checkPermission("settings-generalsettings/systemtasks-write", permissionsData) &&
                        <Button onClick={() => setShowUpdateSupplierBalance(true)} className="mb-3" type="button">{t('SettingsSystemTasks.reupdate')}</Button>
                    }
                </Col>
            </Row>
            <Row>
                <Col sm="12" className="d-flex align-items-center justify-content-start">
                    <span className="mr-3 mb-3">{t('SettingsSystemTasks.reUpdateClientInfo')}</span>{" "}
                    {checkPermission("settings-generalsettings/systemtasks-write", permissionsData) &&
                        <Button onClick={() => setShowUpdateClientInfo(true)} className="mb-3" type="button">{t('SettingsSystemTasks.reupdate')}</Button>
                    }
                </Col>
            </Row>
            <Row>
                <Col sm="12" className="d-flex align-items-center justify-content-start">
                    <span className="mr-3 mb-3">{t('SettingsSystemTasks.reUpdateSupplierInfo')}</span>{" "}
                    {checkPermission("settings-generalsettings/systemtasks-write", permissionsData) &&
                        <Button onClick={() => setShowUpdateSupplierInfo(true)} className="mb-3" type="button">{t('SettingsSystemTasks.reupdate')}</Button>
                    }
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm="12">
                    <span className="mr-3 mb-3">{t('SettingsSystemTasks.syncClientPaymentsWithSales')}</span>
                    <Button onClick={() => setShowSyncModal(true)} disabled={disableSyncCP}>{t('SettingsSystemTasks.sync')}</Button>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm="12">
                    <span className={"mr-3 mb-3"}>Μεταφορά υπολοίπων έτους</span>
                    <Button onClick={() => setShowCreateCensus(true)}>Μεταφορά</Button>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm="12">
                    <span className={"mr-3 mb-3"}>Ενημέρωση του υπολοίπου των παγίων</span>
                    <Button onClick={() => setShowUpdateAssetBalance(true)}>Ενημέρωση</Button>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col sm="12">
                    <span className={"mr-3 mb-3"}>Επαναϋπολογισμός τρέχων υπολοίπων λογ. όψεως</span>
                    <Button onClick={() => setShowUpdateBankBalance(true)}>Επαναϋπολογισμός</Button>
                </Col>
            </Row>
            {/* Confirm Category Change */}
            <Modal className="themeModal" show={showUpdateProductBalance} onHide={() => setShowUpdateProductBalance(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SettingsSystemTasks.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('SettingsSystemTasks.message')}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowUpdateProductBalance(false)}>
                        {t('SettingsSystemTasks.no')}
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirmUpdateProductBalance()} disabled={productLoader}>
                        {t('SettingsSystemTasks.yes')}
                        {productLoader && (<span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="themeModal" show={showUpdateClientBalance} onHide={() => setShowUpdateClientBalance(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SettingsSystemTasks.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('SettingsSystemTasks.clientMessage')}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowUpdateClientBalance(false)}>
                        {t('SettingsSystemTasks.no')}
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirmUpdateClientBalance()} disabled={clientLoader}>
                        {t('SettingsSystemTasks.yes')}
                        {clientLoader && (
                            <span
                                className="spinner-border spinner-border-sm ml-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="themeModal" show={showUpdateSupplierBalance} onHide={() => setShowUpdateSupplierBalance(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SettingsSystemTasks.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('SettingsSystemTasks.supplierMessage')}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowUpdateSupplierBalance(false)}>
                        {t('SettingsSystemTasks.no')}
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirmUpdateSupplierBalance()} disabled={supplierLoader}>
                        {t('SettingsSystemTasks.yes')}
                        {supplierLoader && (
                            <span
                                className="spinner-border spinner-border-sm ml-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="themeModal" show={showUpdateClientInfo} onHide={() => !clientUpdateLoader && setShowUpdateClientInfo(false)}>
                <Modal.Header closeButton disabled={clientUpdateLoader}>
                    <Modal.Title>{t('SettingsSystemTasks.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('SettingsSystemTasks.clientUpdateMessage')}
                    <br/><br/>
                    {clientUpdateModalBody}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" disabled={clientUpdateLoader} onClick={() => setShowUpdateClientInfo(false)}>
                        {t('SettingsSystemTasks.no')}
                    </Button>
                    <Button variant="primary" disabled={clientUpdateLoader} onClick={() => handleConfirmUpdateClientInfo()}>
                        {t('SettingsSystemTasks.yes')}
                        {clientUpdateLoader && (
                            <span
                                className="spinner-border spinner-border-sm ml-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal className="themeModal" show={showUpdateSupplierInfo} onHide={() => !supplierUpdateLoader && setShowUpdateSupplierInfo(false)}>
                <Modal.Header closeButton disabled={supplierUpdateLoader}>
                    <Modal.Title>{t('SettingsSystemTasks.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('SettingsSystemTasks.supplierUpdateMessage')}
                    <br/><br/>
                    {supplierUpdateModalBody}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" disabled={supplierUpdateLoader} onClick={() => setShowUpdateSupplierInfo(false)}>
                        {t('SettingsSystemTasks.no')}
                    </Button>
                    <Button variant="primary" disabled={supplierUpdateLoader} onClick={() => handleConfirmUpdateSupplierInfo()}>
                        {t('SettingsSystemTasks.yes')}
                        {supplierUpdateLoader && (
                            <span
                                className="spinner-border spinner-border-sm ml-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showSyncModal} onHide={() => setShowSyncModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SettingsSystemTasks.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('SettingsSystemTasks.syncMessage')}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowSyncModal(false)}>
                        {t('SettingsSystemTasks.no')}
                    </Button>
                    <Button variant="primary" onClick={() => syncClientPaymentsWithSales()}>
                        {t('SettingsSystemTasks.yes')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showCreateCensus} onHide={() => setShowCreateCensus(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Μεταφορά υπολοίπων μέσω απογραφής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant={"secondary"}>Πραγματοποιείται η μεταφορά υπολοίπων της τωρινής χρονιάς, στην επόμενη χρονιά, μέσω της δημιουργίας απογραφής.</Alert>
                    <Input
                        name={"censusYear"}
                        label={"Χρονιά"}
                        className={"mb-2"}
                        disabled={true}
                        value={censusSend.year}
                    />
                    <Row>
                        <Col md={6}>
                            <BetterCheckBox
                                checked={censusSend.doClients}
                                className={"mt-1"}
                                text={"Απογραφή πελατών"}
                                onChange={(e) => {setCensusSend({...censusSend, doClients: e.target.checked})}}
                            />
                        </Col>
                        {censusSend.doClients === true && (
                            <Col md={6}>
                                <Input
                                    name={"doClientsDate"}
                                    unlabbled={true}
                                    value={censusSend.doClientsDate}
                                    placeholder={"Ημερομηνία απογραφής"}
                                    onChange={(e) => {setCensusSend({...censusSend, doClientsDate: e.target.value})}}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md={6}>
                            <BetterCheckBox
                                checked={censusSend.doSuppliers}
                                className={"mt-1"}
                                text={"Απογραφή προμηθευτών"}
                                onChange={(e) => {setCensusSend({...censusSend, doSuppliers: e.target.checked})}}
                            />
                        </Col>
                        {censusSend.doSuppliers === true && (
                            <Col md={6}>
                                <Input
                                    name={"doSuppliersDate"}
                                    unlabbled={true}
                                    value={censusSend.doSuppliersDate}
                                    placeholder={"Ημερομηνία απογραφής"}
                                    onChange={(e) => {setCensusSend({...censusSend, doSuppliersDate: e.target.value})}}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md={6}>
                            <BetterCheckBox
                                checked={censusSend.doProducts}
                                className={"mt-1"}
                                text={"Απογραφή ειδών"}
                                onChange={(e) => {setCensusSend({...censusSend, doProducts: e.target.checked})}}
                            />
                        </Col>
                        {censusSend.doProducts === true && (
                            <Col md={6}>
                                <Input
                                    name={"doProductsDate"}
                                    unlabbled={true}
                                    value={censusSend.doProductsDate}
                                    placeholder={"Ημερομηνία απογραφής"}
                                    onChange={(e) => {setCensusSend({...censusSend, doProductsDate: e.target.value})}}
                                />
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Col md={6}>
                            <BetterCheckBox
                                name={"doFixedAssets"}
                                checked={censusSend.doFixedAssets}
                                className={"mt-1"}
                                text={"Απογραφή παγίων"}
                                onChange={(e) => {setCensusSend({...censusSend, doFixedAssets: e.target.checked})}}
                            />
                        </Col>
                        {censusSend.doFixedAssets === true && (
                            <Col md={6}>
                                <Input
                                    name={"doFixedAssetsDate"}
                                    unlabbled={true}
                                    value={censusSend.doFixedAssetsDate}
                                    placeholder={"Ημερομηνία απογραφής"}
                                    onChange={(e) => {setCensusSend({...censusSend, doFixedAssetsDate: e.target.value})}}
                                />
                            </Col>
                        )}
                    </Row>
                    {(censusSend.doClients === true || censusSend.doSuppliers === true || censusSend.doProducts === true || censusSend.doFixedAssets === true) && (
                        <Alert className={"mt-2"} variant={"danger"}>Η ημερομηνία πρέπει αυστηρά να έχει την μορφή ΗΗ/ΜΜ/ΧΧΧΧ, π.χ. 06/01/2024</Alert>
                    )}
                    {createCensusInvalid() && (
                        <div style={{color: "red"}}>(*) Επιλέξτε τουλάχιστον ένα πεδίο απογραφής και εισάγετε σωστά την ημερομηνία. Η χρονιά της ημερομηνίας πρέπει να είναι ίδια με της απογραφής.</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowCreateCensus(false)}>Ακύρωση</Button>
                    <Button variant="primary" onClick={() => createCensusClicked()} disabled={censusLoad || createCensusInvalid()}>Μεταφορά {censusLoad && <Spinner animation="border" variant="dark" />}</Button>
                </Modal.Footer>
            </Modal>

            <Modal className="themeModal" show={showUpdateAssetBalance} onHide={() => setShowUpdateAssetBalance(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('SettingsSystemTasks.warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είασαστε σίγουροι ότι θέλετε να ενημερώσετε το υπόλοιπο των παγίων; Η διαδικασία μπορεί να διαρκέσει λίγα λεπτά.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowUpdateAssetBalance(false)}>
                        {t('SettingsSystemTasks.no')}
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirmUpdateAssetBalance()} disabled={assetBalanceLoader}>
                        {t('SettingsSystemTasks.yes')}
                        {assetBalanceLoader && (<span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showUpdateBankBalance} onHide={() => setShowUpdateBankBalance(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Επαναϋπολογισμός υπολοίπου όψεως</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingMyAccounts ? (
                        <span>Παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation="border" variant="dark" /></span>
                    ) : (
                        <div>
                            <Dropdown
                                name={"selectedBankAccount"}
                                label={"Τραπεζικός λογαριασμός"}
                                options={accountOptions}
                                defaultValue={accountOptions.find((el) => el.value === selectedBankAccount)}
                                key={selectedBankAccount}
                                onChange={(e) => setSelectedBankAccount(e.value)}
                            />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowUpdateBankBalance(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleRecalculateBalances()} disabled={bankBalanceLoader || loadingMyAccounts || isEmpty(selectedBankAccount)}>
                        Επαναϋπολογισμός {bankBalanceLoader && <Spinner className={"ml-2"} animation="border" variant="dark" />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default SystemTasks;
